export const TABLE_STICKY_CELL_CLASS_NAME = 'sticky left-0 whitespace-nowrap z-20 bg-inherit'
